export default __webpack_public_path__ + "static/iconfinder_13_3319631-e036924d6f8cfa99ea24c0a979724390.png";